import { supabase } from '../lib/supabase/client';
import { Booking } from '../types/models';

interface BookingEmailData {
  bookingId: string;
  guestEmail: string;
  guestName: string;
  roomName: string;
  checkInDate: string;
  checkOutDate: string;
  numberOfGuests: number;
  totalPrice: number;
  ownerEmail: string;
}

export const emailService = {
  /**
   * Send booking confirmation email to guest and notification to owner
   */
  async sendBookingConfirmation(
    booking: Booking,
    roomName: string,
    ownerEmail: string = 'prenot.23paglia.bergamoitaly@gmail.com'
  ): Promise<{ success: boolean; error?: string }> {
    try {
      const emailData: BookingEmailData = {
        bookingId: booking.id,
        guestEmail: booking.guestEmail,
        guestName: booking.guestName,
        roomName: roomName,
        checkInDate: booking.checkInDate,
        checkOutDate: booking.checkOutDate,
        numberOfGuests: booking.numberOfGuests,
        totalPrice: Number(booking.totalPrice),
        ownerEmail: ownerEmail,
      };

      const { data, error } = await supabase.functions.invoke('send-booking-email', {
        body: emailData,
      });

      if (error) {
        console.error('Error sending booking emails:', error);
        return { success: false, error: error.message };
      }

      console.log('Booking emails sent successfully:', data);
      return { success: true };
    } catch (error) {
      console.error('Unexpected error sending booking emails:', error);
      return { 
        success: false, 
        error: error instanceof Error ? error.message : 'Unknown error' 
      };
    }
  },

  /**
   * Send test email to verify Resend integration
   */
  async sendTestEmail(recipientEmail: string): Promise<{ success: boolean; error?: string }> {
    try {
      const { data, error } = await supabase.functions.invoke('send-booking-email', {
        body: {
          bookingId: 'TEST-123',
          guestEmail: recipientEmail,
          guestName: 'Test Guest',
          roomName: 'Test Room',
          checkInDate: new Date().toISOString().split('T')[0],
          checkOutDate: new Date(Date.now() + 86400000).toISOString().split('T')[0],
          numberOfGuests: 2,
          totalPrice: 120,
          ownerEmail: 'prenot.23paglia.bergamoitaly@gmail.com',
        },
      });

      if (error) {
        console.error('Error sending test email:', error);
        return { success: false, error: error.message };
      }

      return { success: true };
    } catch (error) {
      console.error('Unexpected error sending test email:', error);
      return { 
        success: false, 
        error: error instanceof Error ? error.message : 'Unknown error' 
      };
    }
  },
};